
import { createContext, Dispatch, ReactElement, useContext, useReducer } from "react"
import { Action, initialState } from "./MembershipReducer"
import { MembershipState } from "./MembershipState"

interface StoreProviderProps {
    children: ReactElement
    initialState: MembershipState
    reducer: (state: MembershipState, action: Action) => MembershipState
}

const MembershipStore = createContext<[MembershipState, Dispatch<Action>]>([initialState, () => { null }])

MembershipStore.displayName = `MembershipStore`

export const useMembershipStore = () => useContext(MembershipStore)

export const StoreProvider = (props: StoreProviderProps) => {
    const { children, initialState, reducer } = props
    const [globalState, dispatch] = useReducer(reducer, initialState)

    return (
        <MembershipStore.Provider value={[globalState, dispatch]}>{children}</MembershipStore.Provider>
    )
}